module.exports = __webpack_public_path__ + "img/珠宝-首饰.a4934779.jpg";